import { msg } from '@lingui/macro';
import { IconPackageImport } from '@tabler/icons-react';
import type { ImporterDescriptor } from '../../../descriptors/types';

const descriptor: ImporterDescriptor = {
  id: 'productAllInOneImport',
  status: 'active',
  category: 'product-data',
  popularity: 3,
  icon: IconPackageImport,
  title: msg`Product data import`,
  shortTitle: msg`Product catalogue update`,
  whenToUse: msg`Update or create products in your portfolio. The most common way to bring in new vintages, SKUs, and tasting notes.`,
  outputDescription: msg`Creates or updates products, vintages, SKUs and tasting notes in your portfolio.`,
  intents: [
    'Update product details from a supplier sheet',
    'Add new wines from a supplier',
    'Refresh vintages and tasting notes',
    'Import a supplier catalogue',
    'Send a catalogue to suppliers',
  ],
  keywords: [
    'catalogue',
    'portfolio',
    'supplier',
    'vintage',
    'SKU',
    'tasting note',
    'product',
    'wine',
    'beer',
    'spirit',
    'sparkling',
    'rose',
  ],
  synonyms: ['wines', 'spirits', 'beer', 'beverages', 'inventory'],
  inputHints: {
    fileTypes: ['xlsx'],
    sampleHeaders: [
      'Product short name',
      'Producer name',
      'Product vintage',
      'Country',
      'Region',
      'Alcohol',
      'Product External ID',
      'Tasting notes',
    ],
    requiredColumns: ['Product External ID'],
  },
};

export default descriptor;
